import { getAuthorizationProperties } from "./authorizationHelper";
import { ICountry } from "../models/country";

export async function getCountries(
    guid?: string | undefined,
    userDropdown?: boolean,
    isAcer?: boolean
): Promise<ICountry[]> {
    const params = new URLSearchParams();
    if (guid) {
        params.append("blockGuid", guid);
    }
    if (userDropdown) {
        params.append("userDropdown", userDropdown.toString());
    }
    if (isAcer) {
        params.append("isAcer", isAcer.toString());
    }

    let res = await fetch(`/api/countries?` + params.toString(), {
        method: "GET",
        ...getAuthorizationProperties({ "Content-Type": "application/json" }),
    });
    return res.json();
}

export async function getCountry(guid: string): Promise<ICountry> {
    let res = await fetch(`/api/countries/${guid}`, {
        method: "GET",
        ...getAuthorizationProperties({ "Content-Type": "application/json" }),
    });
    return res.json();
}

export async function getParts(guid: string): Promise<ICountry[]> {
    const res = await fetch(`/api/countries/parts/${guid}`, {
        method: "GET",
        ...getAuthorizationProperties({ "Content-Type": "application/json" }),
    });
    return res.json();
}

export async function getParent(guid: string): Promise<ICountry> {
    const res = await fetch(`/api/countries/parent/${guid}`, {
        method: "GET",
        ...getAuthorizationProperties({ "Content-Type": "application/json" }),
    });
    return res.json();
}

export async function updateCountryInvolment(guid: string) {
    await fetch(`/api/countries/involvement/${guid}`, {
        method: "PATCH",
        ...getAuthorizationProperties({ "Content-Type": "application/json" }),
    });
}

export async function getNonInvolvedCountries(): Promise<string[]> {
    const res = await fetch(`/api/countries/nonInvolved`, {
        method: "GET",
        ...getAuthorizationProperties({ "Content-Type": "application/json" }),
    });
    return res.json();
}
